import { takeEvery, fork, put, all, call } from "redux-saga/effects";
// Login Redux States
import {
  //   GET_VENDOR_DETAILS,
  VENDORS,
  VENDORS_ADD,
  VENDORS_DELETE,
  UPLOAD_REQUEST,
  UPLOAD_PRODUCTVENDORS_REQUEST,
  VENDOR_GST_VALIDATION,
} from "./actionTypes";
import {
  apiError,
  getVendors,
  vendorListSuccessful,
  vendorAddSuccessful,
  InputChangeValue,

  //   vendor_row_successfull,
} from "./actions";

// AUTH related methods
import {
  postAdd,
  getList,
  postEdit,
  postDelete,
  // getRowData,
  postUpload,
} from "../../../helpers/Helper";
import swal from "sweetalert";

function* getVendor() {
  try {
    const response = yield call(getList, "/masters/vendors/", {});
    yield put(vendorListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

//If user is login then dispatch redux action's are directly from here.
function* AddVendor({ payload: { vendor } }) {
  try {
    if (!vendor.id) {
      const response = yield call(postAdd, "/masters/vendors/", vendor);
      if (response.status === 201) {
        yield put(getVendors());

        swal("Your Vendor Added Successfully.!", {
          icon: "success",
          timer: 1500,
        });
      } else {
        swal("Sorry! Unable to Added Vendor. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(vendorAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/vendors/" + vendor.id,
        vendor
      );
      if (response.status === 200) {
        swal("Your Vendor Edited Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getVendors());
      } else {
        swal("Sorry! Unable to Edited Vendor. Please Try Again!", {
          icon: "error",
        });
      }

      yield put(vendorAddSuccessful(null));
    }
  } catch (error) {
    swal("There was an error in submitting data to Server", {
      icon: "error",
    });
    // yield put(apiError(error));
  }
}

//If user is login then dispatch redux action's are directly from here.
function* deleteVendor(venId) {
  try {
    const response = yield call(
      postDelete,
      "/masters/vendors/" + venId.payload.venId
    );

    if (response.status === 204) {
      swal("Your Vendor has been deleted!", {
        icon: "success",
        timer: 1500,
      });
      yield put(getVendors());
    } else {
      swal("Sorry! Your Vendor has been not deleted!", {
        icon: "error",
      });
    }
    // yield put(locationDeleteSuccessful(response.statusText))
  } catch (error) {
    swal(error, {
      icon: "error",
    });

    //yield put(apiError(error));
  }
}

function* csvUpload({ payload: { file, history } }) {
  try {
    const response = yield call(postUpload, "/masters/vendor/", file);
    if (response.status === "200") {
      swal("Poof! Your Vendor Imported Successfully.!", {
        icon: "success",
      });
      history.push("/Vendors");
    } else {
      swal("Sorry! Unable to Import Vendor. Please try again!", {
        icon: "error",
      });
    }
    yield put(vendorAddSuccessful(null));
  } catch (error) {
    swal(error, {
      icon: "error",
    });
    //yield put(apiError(error));
  }
}

function* csvProductVendorUpload({ payload: { file, history } }) {
  try {
    const response = yield call(
      postUpload,
      "/apimasters/csvproductvendorupload/",
      file
    );

    if (response.status === "200") {
      swal("Poof! Your Vendor Imported Successfully.!", {
        icon: "success",
      });
      history.push("/Products");
    } else {
      swal("Sorry! Unable to Import Vendor. Please try again!", {
        icon: "error",
      });
    }
    yield put(vendorAddSuccessful(null));
  } catch (error) {
    swal(error, {
      icon: "error",
    });
    //yield put(apiError(error));
  }
}
function* vendorGSTValidation({ payload: { data } }) {

  try {
    const response = yield call(
      postAdd,
      "/masters/vendors/gst_validation/",
      data
    );
    if (response.status === 200) {
    }
  } catch (error) {
    yield put(
      InputChangeValue({
        key: "gstno",
        value: "",
      })
    );
    swal("Poof! GST No already exists!", {
      icon: "error",
    });

    yield put(apiError(error));
  }
}

export function* watchgetVendors() {
  yield takeEvery(VENDORS, getVendor);
}
export function* watchVendorAdd() {
  yield takeEvery(VENDORS_ADD, AddVendor);
}

export function* watchVendorDelete() {
  yield takeEvery(VENDORS_DELETE, deleteVendor);
}

export function* watchVendorImportCsv() {
  yield takeEvery(UPLOAD_REQUEST, csvUpload);
}

export function* watchProductVendorImportCsv() {
  yield takeEvery(UPLOAD_PRODUCTVENDORS_REQUEST, csvProductVendorUpload);
}
export function* watchVendorGSTValidation() {
  yield takeEvery(VENDOR_GST_VALIDATION, vendorGSTValidation);
}
function* VendorSaga() {
  yield all([
    fork(watchgetVendors),
    fork(watchVendorAdd),
    fork(watchVendorDelete),
    fork(watchVendorImportCsv),
    fork(watchProductVendorImportCsv),
    fork(watchVendorGSTValidation),
  ]);
}

export default VendorSaga;
